// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NotificationCenter_notificationCenter__PmPsI {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 9999;
}

.NotificationCenter_notificationButton__19\\+KF {
  position: relative;
  background: #1053ad;
  border: none;
  border-radius: 50%;
  width: 48px;
  height: 48px;
  font-size: 20px;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(16, 83, 173, 0.3);
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}
.NotificationCenter_notificationButton__19\\+KF:hover {
  background: #0d4299;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(16, 83, 173, 0.4);
}
.NotificationCenter_notificationButton__19\\+KF.NotificationCenter_hasUnread__ndTPb {
  animation: NotificationCenter_pulse__2it0s 2s infinite;
}

.NotificationCenter_badge__tFM1l {
  position: absolute;
  top: -4px;
  right: -4px;
  background: #f44336;
  color: white;
  border-radius: 10px;
  padding: 2px 6px;
  font-size: 11px;
  font-weight: 600;
  min-width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid white;
}

.NotificationCenter_notificationPanel__SSrHO {
  position: absolute;
  top: 60px;
  right: 0;
  width: 400px;
  max-height: 500px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
  border: 1px solid #e0e0e0;
  overflow: hidden;
  animation: NotificationCenter_slideDown__nH49d 0.3s ease-out;
}

.NotificationCenter_panelHeader__e4HqE {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #e0e0e0;
  background: #f8f9fa;
}
.NotificationCenter_panelHeader__e4HqE h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.NotificationCenter_headerActions__a-Z8I {
  display: flex;
  align-items: center;
  gap: 8px;
}

.NotificationCenter_clearAllButton__4-8\\+q {
  background: none;
  border: 1px solid #ddd;
  color: #666;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.NotificationCenter_clearAllButton__4-8\\+q:hover {
  background: #f5f5f5;
  border-color: #ccc;
}

.NotificationCenter_closeButton__-Ph7S {
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
  padding: 4px;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s ease;
  color: #666;
}
.NotificationCenter_closeButton__-Ph7S:hover {
  background-color: rgba(0, 0, 0, 0.1);
  color: #333;
}

.NotificationCenter_notificationList__8ny2P {
  max-height: 400px;
  overflow-y: auto;
  padding: 8px 0;
}

.NotificationCenter_emptyState__h4U-9 {
  text-align: center;
  padding: 40px 20px;
  color: #999;
}
.NotificationCenter_emptyState__h4U-9 .NotificationCenter_emptyIcon__x9xqW {
  font-size: 32px;
  margin-bottom: 8px;
}
.NotificationCenter_emptyState__h4U-9 p {
  margin: 0;
  font-size: 14px;
}

.NotificationCenter_notificationItem__OjJyG {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 12px 20px;
  border-bottom: 1px solid #f0f0f0;
  transition: all 0.2s ease;
  border-left: 4px solid transparent;
}
.NotificationCenter_notificationItem__OjJyG:hover {
  background: #f8f9fa;
}
.NotificationCenter_notificationItem__OjJyG.NotificationCenter_unread__zNNru {
  background: #f0f8ff;
  border-left-color: #2196f3;
}
.NotificationCenter_notificationItem__OjJyG:last-child {
  border-bottom: none;
}

.NotificationCenter_itemContent__hv94- {
  flex: 1 1;
}

.NotificationCenter_itemHeader__T1lTh {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
}
.NotificationCenter_itemHeader__T1lTh .NotificationCenter_icon__Y1Dve {
  font-size: 16px;
  line-height: 1;
}
.NotificationCenter_itemHeader__T1lTh .NotificationCenter_title__pilWs {
  font-weight: 600;
  font-size: 13px;
  color: #333;
  flex: 1 1;
}
.NotificationCenter_itemHeader__T1lTh .NotificationCenter_time__FogjM {
  font-size: 11px;
  color: #999;
  white-space: nowrap;
}

.NotificationCenter_message__mZ8Yz {
  font-size: 12px;
  color: #666;
  line-height: 1.4;
  margin-left: 24px;
}

.NotificationCenter_removeButton__ZJUtv {
  background: none;
  border: none;
  font-size: 14px;
  cursor: pointer;
  padding: 4px;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s ease;
  color: #999;
  opacity: 0;
  margin-left: 8px;
}
.NotificationCenter_removeButton__ZJUtv:hover {
  background-color: rgba(0, 0, 0, 0.1);
  color: #666;
}

.NotificationCenter_notificationItem__OjJyG:hover .NotificationCenter_removeButton__ZJUtv {
  opacity: 1;
}

.NotificationCenter_success__UnJ56 .NotificationCenter_icon__Y1Dve {
  color: #4caf50;
}
.NotificationCenter_success__UnJ56 .NotificationCenter_title__pilWs {
  color: #2e7d32;
}

.NotificationCenter_error__JFtwF .NotificationCenter_icon__Y1Dve {
  color: #f44336;
}
.NotificationCenter_error__JFtwF .NotificationCenter_title__pilWs {
  color: #c62828;
}

.NotificationCenter_warning__XXtn0 .NotificationCenter_icon__Y1Dve {
  color: #ff9800;
}
.NotificationCenter_warning__XXtn0 .NotificationCenter_title__pilWs {
  color: #ef6c00;
}

.NotificationCenter_info__hnXrE .NotificationCenter_icon__Y1Dve {
  color: #2196f3;
}
.NotificationCenter_info__hnXrE .NotificationCenter_title__pilWs {
  color: #1565c0;
}

@keyframes NotificationCenter_slideDown__nH49d {
  from {
    transform: translateY(-10px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
@keyframes NotificationCenter_pulse__2it0s {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}
@media (max-width: 768px) {
  .NotificationCenter_notificationCenter__PmPsI {
    top: 10px;
    right: 10px;
    transition: all 0.3s ease;
  }
  .NotificationCenter_notificationCenter__PmPsI.NotificationCenter_chatDialogOpen__rnBf8 {
    z-index: 999;
    right: 70px;
  }
  .NotificationCenter_notificationButton__19\\+KF {
    width: 44px;
    height: 44px;
    font-size: 18px;
  }
  .NotificationCenter_notificationPanel__SSrHO {
    width: calc(100vw - 20px);
    right: -10px;
    z-index: 999;
  }
  .NotificationCenter_chatDialogOpen__rnBf8 .NotificationCenter_notificationPanel__SSrHO {
    right: -70px;
    width: calc(100vw - 80px);
  }
  .NotificationCenter_panelHeader__e4HqE {
    padding: 12px 16px;
  }
  .NotificationCenter_panelHeader__e4HqE h3 {
    font-size: 14px;
  }
  .NotificationCenter_notificationItem__OjJyG {
    padding: 10px 16px;
  }
  .NotificationCenter_itemHeader__T1lTh .NotificationCenter_title__pilWs {
    font-size: 12px;
  }
  .NotificationCenter_itemHeader__T1lTh .NotificationCenter_time__FogjM {
    font-size: 10px;
  }
  .NotificationCenter_message__mZ8Yz {
    font-size: 11px;
    margin-left: 20px;
  }
}
.NotificationCenter_notificationCenter__PmPsI.NotificationCenter_chatDialogOpen__rnBf8 {
  z-index: 999;
}
.NotificationCenter_notificationCenter__PmPsI.NotificationCenter_chatDialogOpen__rnBf8 .NotificationCenter_notificationPanel__SSrHO {
  z-index: 999;
}`, "",{"version":3,"sources":["webpack://./src/components/NotificationCenter/index.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;AACF;;AAEA;EACE,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,6CAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACF;AACE;EACE,mBAAA;EACA,2BAAA;EACA,6CAAA;AACJ;AAEE;EACE,sDAAA;AAAJ;;AAIA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;AADF;;AAIA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,0CAAA;EACA,yBAAA;EACA,gBAAA;EACA,4DAAA;AADF;;AAIA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,gCAAA;EACA,mBAAA;AADF;AAGE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AADJ;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAFF;;AAKA;EACE,gBAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;AAFF;AAIE;EACE,mBAAA;EACA,kBAAA;AAFJ;;AAMA;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;AAHF;AAKE;EACE,oCAAA;EACA,WAAA;AAHJ;;AAOA;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;AAJF;;AAOA;EACE,kBAAA;EACA,kBAAA;EACA,WAAA;AAJF;AAME;EACE,eAAA;EACA,kBAAA;AAJJ;AAOE;EACE,SAAA;EACA,eAAA;AALJ;;AASA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,kBAAA;EACA,gCAAA;EACA,yBAAA;EACA,kCAAA;AANF;AAQE;EACE,mBAAA;AANJ;AASE;EACE,mBAAA;EACA,0BAAA;AAPJ;AAUE;EACE,mBAAA;AARJ;;AAYA;EACE,SAAA;AATF;;AAYA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AATF;AAWE;EACE,eAAA;EACA,cAAA;AATJ;AAYE;EACE,gBAAA;EACA,eAAA;EACA,WAAA;EACA,SAAA;AAVJ;AAaE;EACE,eAAA;EACA,WAAA;EACA,mBAAA;AAXJ;;AAeA;EACE,eAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;AAZF;;AAeA;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;AAZF;AAcE;EACE,oCAAA;EACA,WAAA;AAZJ;;AAgBA;EACE,UAAA;AAbF;;AAkBE;EACE,cAAA;AAfJ;AAkBE;EACE,cAAA;AAhBJ;;AAqBE;EACE,cAAA;AAlBJ;AAqBE;EACE,cAAA;AAnBJ;;AAwBE;EACE,cAAA;AArBJ;AAwBE;EACE,cAAA;AAtBJ;;AA2BE;EACE,cAAA;AAxBJ;AA2BE;EACE,cAAA;AAzBJ;;AA8BA;EACE;IACE,4BAAA;IACA,UAAA;EA3BF;EA6BA;IACE,wBAAA;IACA,UAAA;EA3BF;AACF;AA8BA;EACE;IACE,mBAAA;EA5BF;EA8BA;IACE,sBAAA;EA5BF;EA8BA;IACE,mBAAA;EA5BF;AACF;AAgCA;EACE;IACE,SAAA;IACA,WAAA;IACA,yBAAA;EA9BF;EAiCE;IACE,YAAA;IAEA,WAAA;EAhCJ;EAoCA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAlCF;EAqCA;IACE,yBAAA;IACA,YAAA;IACA,YAAA;EAnCF;EAsCE;IACE,YAAA;IACA,yBAAA;EApCJ;EAwCA;IACE,kBAAA;EAtCF;EAwCE;IACE,eAAA;EAtCJ;EA0CA;IACE,kBAAA;EAxCF;EA4CE;IACE,eAAA;EA1CJ;EA6CE;IACE,eAAA;EA3CJ;EA+CA;IACE,eAAA;IACA,iBAAA;EA7CF;AACF;AAiDA;EACE,YAAA;AA/CF;AAiDE;EACE,YAAA;AA/CJ","sourcesContent":[".notificationCenter {\n  position: fixed;\n  top: 20px;\n  right: 20px;\n  z-index: 9999;\n}\n\n.notificationButton {\n  position: relative;\n  background: #1053ad;\n  border: none;\n  border-radius: 50%;\n  width: 48px;\n  height: 48px;\n  font-size: 20px;\n  cursor: pointer;\n  box-shadow: 0 4px 12px rgba(16, 83, 173, 0.3);\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  &:hover {\n    background: #0d4299;\n    transform: translateY(-2px);\n    box-shadow: 0 6px 16px rgba(16, 83, 173, 0.4);\n  }\n\n  &.hasUnread {\n    animation: pulse 2s infinite;\n  }\n}\n\n.badge {\n  position: absolute;\n  top: -4px;\n  right: -4px;\n  background: #f44336;\n  color: white;\n  border-radius: 10px;\n  padding: 2px 6px;\n  font-size: 11px;\n  font-weight: 600;\n  min-width: 18px;\n  height: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 2px solid white;\n}\n\n.notificationPanel {\n  position: absolute;\n  top: 60px;\n  right: 0;\n  width: 400px;\n  max-height: 500px;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);\n  border: 1px solid #e0e0e0;\n  overflow: hidden;\n  animation: slideDown 0.3s ease-out;\n}\n\n.panelHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 20px;\n  border-bottom: 1px solid #e0e0e0;\n  background: #f8f9fa;\n\n  h3 {\n    margin: 0;\n    font-size: 16px;\n    font-weight: 600;\n    color: #333;\n  }\n}\n\n.headerActions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.clearAllButton {\n  background: none;\n  border: 1px solid #ddd;\n  color: #666;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n\n  &:hover {\n    background: #f5f5f5;\n    border-color: #ccc;\n  }\n}\n\n.closeButton {\n  background: none;\n  border: none;\n  font-size: 18px;\n  cursor: pointer;\n  padding: 4px;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n  color: #666;\n\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.1);\n    color: #333;\n  }\n}\n\n.notificationList {\n  max-height: 400px;\n  overflow-y: auto;\n  padding: 8px 0;\n}\n\n.emptyState {\n  text-align: center;\n  padding: 40px 20px;\n  color: #999;\n\n  .emptyIcon {\n    font-size: 32px;\n    margin-bottom: 8px;\n  }\n\n  p {\n    margin: 0;\n    font-size: 14px;\n  }\n}\n\n.notificationItem {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding: 12px 20px;\n  border-bottom: 1px solid #f0f0f0;\n  transition: all 0.2s ease;\n  border-left: 4px solid transparent;\n\n  &:hover {\n    background: #f8f9fa;\n  }\n\n  &.unread {\n    background: #f0f8ff;\n    border-left-color: #2196f3;\n  }\n\n  &:last-child {\n    border-bottom: none;\n  }\n}\n\n.itemContent {\n  flex: 1;\n}\n\n.itemHeader {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 4px;\n\n  .icon {\n    font-size: 16px;\n    line-height: 1;\n  }\n\n  .title {\n    font-weight: 600;\n    font-size: 13px;\n    color: #333;\n    flex: 1;\n  }\n\n  .time {\n    font-size: 11px;\n    color: #999;\n    white-space: nowrap;\n  }\n}\n\n.message {\n  font-size: 12px;\n  color: #666;\n  line-height: 1.4;\n  margin-left: 24px;\n}\n\n.removeButton {\n  background: none;\n  border: none;\n  font-size: 14px;\n  cursor: pointer;\n  padding: 4px;\n  width: 20px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n  color: #999;\n  opacity: 0;\n  margin-left: 8px;\n\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.1);\n    color: #666;\n  }\n}\n\n.notificationItem:hover .removeButton {\n  opacity: 1;\n}\n\n// 不同类型的通知样式\n.success {\n  .icon {\n    color: #4caf50;\n  }\n\n  .title {\n    color: #2e7d32;\n  }\n}\n\n.error {\n  .icon {\n    color: #f44336;\n  }\n\n  .title {\n    color: #c62828;\n  }\n}\n\n.warning {\n  .icon {\n    color: #ff9800;\n  }\n\n  .title {\n    color: #ef6c00;\n  }\n}\n\n.info {\n  .icon {\n    color: #2196f3;\n  }\n\n  .title {\n    color: #1565c0;\n  }\n}\n\n// 动画\n@keyframes slideDown {\n  from {\n    transform: translateY(-10px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n@keyframes pulse {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.05);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n\n// 响应式设计\n@media (max-width: 768px) {\n  .notificationCenter {\n    top: 10px;\n    right: 10px;\n    transition: all 0.3s ease;\n\n    // 当聊天对话框打开时，调整位置和层级\n    &.chatDialogOpen {\n      z-index: 999;\n      // 向左移动，避免与聊天对话框的关闭按钮冲突\n      right: 70px;\n    }\n  }\n\n  .notificationButton {\n    width: 44px;\n    height: 44px;\n    font-size: 18px;\n  }\n\n  .notificationPanel {\n    width: calc(100vw - 20px);\n    right: -10px;\n    z-index: 999;\n\n    // 当聊天对话框打开时，调整面板位置\n    .chatDialogOpen & {\n      right: -70px;\n      width: calc(100vw - 80px);\n    }\n  }\n\n  .panelHeader {\n    padding: 12px 16px;\n\n    h3 {\n      font-size: 14px;\n    }\n  }\n\n  .notificationItem {\n    padding: 10px 16px;\n  }\n\n  .itemHeader {\n    .title {\n      font-size: 12px;\n    }\n\n    .time {\n      font-size: 10px;\n    }\n  }\n\n  .message {\n    font-size: 11px;\n    margin-left: 20px;\n  }\n}\n\n// 当聊天对话框打开时的特殊样式\n.notificationCenter.chatDialogOpen {\n  z-index: 999;\n\n  .notificationPanel {\n    z-index: 999;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"notificationCenter": `NotificationCenter_notificationCenter__PmPsI`,
	"notificationButton": `NotificationCenter_notificationButton__19+KF`,
	"hasUnread": `NotificationCenter_hasUnread__ndTPb`,
	"pulse": `NotificationCenter_pulse__2it0s`,
	"badge": `NotificationCenter_badge__tFM1l`,
	"notificationPanel": `NotificationCenter_notificationPanel__SSrHO`,
	"slideDown": `NotificationCenter_slideDown__nH49d`,
	"panelHeader": `NotificationCenter_panelHeader__e4HqE`,
	"headerActions": `NotificationCenter_headerActions__a-Z8I`,
	"clearAllButton": `NotificationCenter_clearAllButton__4-8+q`,
	"closeButton": `NotificationCenter_closeButton__-Ph7S`,
	"notificationList": `NotificationCenter_notificationList__8ny2P`,
	"emptyState": `NotificationCenter_emptyState__h4U-9`,
	"emptyIcon": `NotificationCenter_emptyIcon__x9xqW`,
	"notificationItem": `NotificationCenter_notificationItem__OjJyG`,
	"unread": `NotificationCenter_unread__zNNru`,
	"itemContent": `NotificationCenter_itemContent__hv94-`,
	"itemHeader": `NotificationCenter_itemHeader__T1lTh`,
	"icon": `NotificationCenter_icon__Y1Dve`,
	"title": `NotificationCenter_title__pilWs`,
	"time": `NotificationCenter_time__FogjM`,
	"message": `NotificationCenter_message__mZ8Yz`,
	"removeButton": `NotificationCenter_removeButton__ZJUtv`,
	"success": `NotificationCenter_success__UnJ56`,
	"error": `NotificationCenter_error__JFtwF`,
	"warning": `NotificationCenter_warning__XXtn0`,
	"info": `NotificationCenter_info__hnXrE`,
	"chatDialogOpen": `NotificationCenter_chatDialogOpen__rnBf8`
};
export default ___CSS_LOADER_EXPORT___;
